var moduleMap = {
	"./Order": () => {
		return Promise.all([__webpack_require__.e(9885), __webpack_require__.e(5016), __webpack_require__.e(5171), __webpack_require__.e(2864), __webpack_require__.e(2265), __webpack_require__.e(8642), __webpack_require__.e(3444), __webpack_require__.e(6067), __webpack_require__.e(1859), __webpack_require__.e(4192), __webpack_require__.e(1170)]).then(() => (() => ((__webpack_require__(75196)))));
	},
	"./Style": () => {
		return Promise.all([__webpack_require__.e(1459), __webpack_require__.e(1725), __webpack_require__.e(9636)]).then(() => (() => ((__webpack_require__(97288)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});